<template>
    <div>
        <van-row>
            <van-col span="12" style="border-right: 1px solid #e3e3e3" @click="showPopupL">分组浏览</van-col>
            <van-col span="12" @click="showPopupR">排序</van-col>
        </van-row>
        <div class="listCon">
            <p :class="{ wfp: 'wf' == url }">
                共检索到<span>{{ totalNum }}</span
                >篇文章
            </p>
            <p v-if="'wf' == url">
                当前检索结果已过滤掉无全文权限的第三方数据库(如中华医学会、ISTIC等)
            </p>
            <!-- <van-list v-model="loading" :finished="finished" :immediate-check="false" offset="10" finished-text="没有更多了" @load="onLoad"> -->
            <van-list v-model="loading" :finished="finished" :immediate-check="false" offset="10" finished-text="没有更多了">
                <div v-for="(item, index) in list" :key="index" class="con">
                    <h4>
                        <router-link
                            v-show="'wf' == url"
                            v-html="index + 1 + ' . ' + (item.fulltextFlag ? '<span>[全文]</span>' : '') + item.ti"
                            :to="{ path: '/wfDetails', query: { artId: item.articleId } }"
                            class="homePan"
                        >
                        </router-link>
                        <router-link
                            v-show="'wfmed' == url"
                            v-html="index + 1 + ' . ' + item.ti"
                            :to="{ path: '/wfmedDetails', query: { url: item.url } }"
                            class="homePan"
                        ></router-link>
                    </h4>
                    <!-- <p>Determination of ofloxacin enantiomers by CE method using</p> -->
                    <div v-show="'wf' == url">
                        <!-- <p>
                            <span>来源:</span><span class="spanCon">《{{ item.so }}》{{ item.vl }}</span>
                        </p>
                        <p>
                            <span>:</span><span class="spanCon">{{ item.au }}</span>
                        </p>
                        <p>
                            <span>:</span><span class="spanCon">{{ item.kw }}</span>
                        </p> -->
                        <dl>
                            <dt>来源:</dt>
                            <dd>《{{ item.so }}》{{ item.vl }}</dd>
                        </dl>
                        <dl>
                            <dt>作者:</dt>
                            <dd>{{ item.au }}</dd>
                        </dl>
                        <dl>
                            <dt>关键词:</dt>
                            <dd>{{ item.kw }}</dd>
                        </dl>
                    </div>
                    <div v-show="'wfmed' == url" v-html="item.intro"></div>
                </div>
                <div v-show="listShow">
                    暂无数据
                </div>
            </van-list>
        </div>
        <van-popup v-model="showL" position="left" :style="{ width: '50%', height: '100%' }" get-container="#app">
            <van-cell title="分组浏览" />
            <van-collapse v-model="activeName" accordion @change="facet($event)">
                <van-collapse-item v-for="(item, index) in collapseIteM" :key="index" :title="item.title" :name="item.name" ref="checkboxGroup">
                    <p style="text-align:center;padding: 10px 0;" v-show="shoeP">
                        暂无数据
                    </p>
                    <van-loading size="24px" v-show="shoeLo">加载中...</van-loading>
                    <van-radio-group v-model="result['result' + index]" v-if="index == 0 && Url == 'wfmed'">
                        <van-radio v-for="(item1, index1) in activList[index]" :key="index1" :name="'facet' + item1.label">
                            {{ item1.label }}<span style="float:right">({{ item1.value }})</span>
                        </van-radio>
                    </van-radio-group>
                    <van-checkbox-group v-model="result['result' + index]" v-else>
                        <van-checkbox v-for="(item1, index1) in activList[index]" :key="index1" :name="'facet' + item1.label">
                            {{ item1.label }}<span style="float:right">({{ item1.value }})</span>
                        </van-checkbox>
                    </van-checkbox-group>
                </van-collapse-item>
            </van-collapse>
            <van-button type="info" block @click="confirm()" style="bottom: 2.3rem;">确认</van-button>
            <van-button type="info" block @click="cancel()" style="background: #2c87cf; border:#2c87cf;">清除筛选</van-button>
        </van-popup>

        <van-popup v-model="showR" position="right" :style="{ width: '50%', height: '100%' }" get-container="#app">
            <van-cell title="排序" />
            <div class="right">
                <van-cell v-for="(item1, index1) in derUrl" :key="index1" :class="{ active: index1 == currentRight }">
                    <template slot="title">
                        <span
                            class="custom-title"
                            style="width: 100%; display: block;"
                            @click="facetCick($event, index1, '', 'right')"
                            :data-name="item1.name"
                            >{{ item1.title }}</span
                        >
                    </template>
                </van-cell>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { Toast } from "vant";
import qs from "qs";

export default {
    props: ["collapseItem", "url", "derUrl"],
    data() {
        return {
            list: [],
            loading: false,
            collapseIteM: this.collapseItem,
            finished: false,
            showL: false,
            wpshowL: false,
            showR: false,
            shoeP: false,
            shoeLo: false,
            isActive: false,
            listShow: false,
            data: {},
            totalNum: 0,
            activeName: "0",
            activList: {},
            Url: this.url,
            pageUrl: "",
            page: 1,
            currentLeft: -1,
            LeftType: "",
            currentRight: -1,
            result: {
                result0: "",
                result1: [],
                result2: [],
                result3: [],
                result4: []
            },
            facetTerm: [],
            fieldValue: {}
        };
    },
    mounted() {
        this.listShow = false;
        this.getSearch();
        let num = 4;
        switch (this.url) {
            case "wfmed":
                num = 2;
                break;
        }
        for (let i = 0; i < num; i++) {
            this.result["result" + i] = [];
            this.activList[i] = [];
        }

        let that = this;
        window.onscroll = function() {
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (Math.ceil(scrollTop + windowHeight) == scrollHeight || Math.floor(scrollTop + windowHeight) == scrollHeight) {
                //写后台加载数据的函数
                that.onLoad();
            }
        };
    },
    methods: {
        getSearch() {
            this.data = this.$route.query;
            //默认列表数据接口调用
            this.$get(this.Url + "/search", this.data).then((response) => {
                if (response.code == 0) {
                    if (response.data.list == null) {
                        this.listShow = true;
                    } else {
                        this.totalNum = response.data.total;
                        this.list = response.data.list;
                        this.pageUrl = response.data.pageUrl;
                        if (this.Url == "wfmed") {
                            this.activList["0"] = response.data.facetList[1].list;
                            this.fieldValue["0"] = response.data.facetList[1].fieldValue;
                        }
                    }
                }
            });
        },
        //分面面板切换
        facet(event) {
            if (event != "") {
                var eventNum = 0;
                switch (event) {
                    // case "$common_year": eventNum = 0; break;
                    // case "$subject_classcode_level": eventNum = 1; break;
                    // case "$core_perio": eventNum = 2; break;
                    // case "$perio_title02": eventNum = 3; break;
                    case "PublishYear":
                        eventNum = 0;
                        break;
                    case "ClassCodeForSearch":
                        eventNum = 1;
                        break;
                    case "Language":
                        eventNum = 2;
                        break;
                    case "PeriodicalTitleForFacet":
                        eventNum = 3;
                        break;
                    case "CLCShort":
                        eventNum = 1;
                        break;
                    case "Source_F":
                        eventNum = 2;
                        break;
                }
                this.data.singleFacetField = event;
                this.shoeLo = true;
                this.shoeP = false;
                delete this.data.sortBy;
                if (event != "00") {
                    this.$get(this.Url + "/facet?" + qs.stringify(this.data), "").then((response) => {
                        this.shoeLo = false;
                        if (response.code == 0) {
                            this.$set(this.activList, eventNum, response.data.list);
                            this.$set(this.fieldValue, eventNum, response.data.fieldValue);
                            if (response.data.length == 0) {
                                this.shoeP = true;
                            } else {
                                this.shoeP = false;
                            }
                        } else {
                            this.shoeP = true;
                            Toast(response.msg);
                        }
                    });
                } else {
                    this.shoeLo = false;
                }
            }
        },
        //点击分面
        facetCick(e, index1, index, LR) {
            if (LR == "right") {
                this.currentRight = index1;
                this.data.sortBy = e.target.dataset.name;
            } else {
                this.currentRight = -1;
            }
            this.$get(this.Url + "/search?" + qs.stringify(this.data), "").then((response) => {
                if (response.code == 0) {
                    if (response.data.list == null) {
                        this.listShow = true;
                    } else {
                        this.listShow = false;
                        this.list = response.data.list;
                        this.totalNum = response.data.total;
                        this.activList = {};
                        if (this.Url == "wfmed") {
                            this.$set(this.activList, 0, response.data.facetList[1].list);
                        }
                    }
                    this.showL = false;
                    this.showR = false;
                    this.activeName = -1;
                } else {
                    Toast("检索失败");
                }
            });
        },
        //加载更多数据
        onLoad() {
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            if (this.$route.name === this.url + "List") {
                this.listShow = false;
                if (this.totalNum == this.list.length) {
                    this.finished = true;
                } else {
                    this.page = Number(this.data.page) + 1;
                    this.data.page = this.page;
                    this.$get(this.Url + "/search?" + qs.stringify(this.data), "").then((response) => {
                        if (response.code == 0) {
                            this.totalNum = response.data.total;
                            this.list = this.list.concat(response.data.list);
                            if (this.Url == "wfmed") {
                                this.activList["0"] = response.data.facetList[1].list;
                                this.fieldValue["0"] = response.data.facetList[1].fieldValue;
                            }
                            if (response.data.list == null) {
                                this.listShow = true;
                            }
                            this.loading = false;
                        }
                    });
                }
            }
        },
        showPopupL() {
            this.showL = true;
        },
        showPopupR() {
            this.showR = true;
        },
        confirm() {
            this.facetTerm = [];
            this.$refs.checkboxGroup.map((val, index) => {
                if (val.title == "出版年份" && this.Url == "wfmed") {
                    if (val.$children != "") {
                        let ref = val.$children[0].value.split("facet")[1];
                        this.facetTerm.push(this.fieldValue[0] + ":" + ref + "-" + ref);
                    }
                } else {
                    if (val.$children != "") {
                        let ref = val.$children[0].value;
                        if (this.activList[index] != undefined) {
                            for (let i = 0; i < this.activList[index].length; i++) {
                                for (let j = 0; j < ref.length; j++) {
                                    if ("facet" + this.activList[index][i].label == ref[j]) {
                                        this.facetTerm.push(this.fieldValue[index] + ":" + this.activList[index][i].key);
                                    }
                                }
                            }
                        }
                    }
                }
                this.data.facetTerm = this.facetTerm;
            });
            delete this.data.singleFacetField;
            this.facetCick();
        },
        cancel() {
            this.activList = {};
            this.facetTerm = [];
            this.page = 1;
            this.showL = false;
            this.result = {
                result0: [],
                result1: [],
                result2: [],
                result3: [],
                result4: []
            };
            delete this.data.facetTerm;
            this.getSearch();
        }
    }
};
</script>
<style lang="less">
.van-checkbox-group,
.van-radio-group {
    > div {
        padding: 0.5rem 0;

        .van-checkbox__label,
        .van-radio__label {
            width: 100%;
        }
    }
}

.van-cell.active {
    color: red;
}

.van-popup {
    overflow: hidden;
    .van-collapse {
        height: calc(100% - 7.6rem);
        overflow: auto;
        // padding-bottom: 4.6rem;
    }
    .van-collapse::after {
        border: 0px solid #fff;
    }
    .van-button--block {
        position: fixed;
        bottom: 0;
    }
}

.van-popup > .van-cell {
    > .van-cell__title {
        > span {
            font-size: 1rem;
            font-weight: 700;
        }
    }
}

.van-popup div > .van-cell span {
    text-align: left;
}
</style>
